import Button, { ButtonProps } from "@mui/material/Button";
import Typography from "@mui/material/Typography";

import LiveViewIcon from "../../../common/components/icons/LiveViewIcon";

interface LiveButtonProps extends ButtonProps {}

const LiveButton = (props: LiveButtonProps): JSX.Element => {
  return (
    <Button
      sx={{
        cursor: "pointer",
      }}
      variant="outlined"
      size="small"
      disableRipple
      startIcon={<LiveViewIcon />}
      {...props}
    >
      <Typography variant="buttonMedium">Live</Typography>
    </Button>
  );
};

export default LiveButton;
